import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "text-slate-900" }
const _hoisted_3 = { class: "relative bg-white rounded-xl sm:rounded-2xl shadow-lg sm:shadow-xl border border-slate-200 overflow-hidden" }
const _hoisted_4 = {
  key: 0,
  class: "absolute inset-0 z-20 flex flex-col items-center justify-center gap-3 rounded-xl bg-white/90 px-4 backdrop-blur-[1px]",
  role: "status",
  "aria-live": "polite"
}
const _hoisted_5 = { class: "text-center text-sm font-semibold text-slate-800" }
const _hoisted_6 = {
  key: 0,
  class: "text-center text-xs text-slate-600"
}
const _hoisted_7 = {
  key: 1,
  class: "flex flex-col gap-3 border-b border-slate-100 bg-gradient-to-r from-sky-50/90 to-white px-3 py-3 sm:flex-row sm:items-center sm:justify-between sm:px-4"
}
const _hoisted_8 = { class: "text-sm text-slate-700" }
const _hoisted_9 = { class: "font-semibold text-slate-900" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "lg:hidden mt-4 text-center" }
const _hoisted_12 = { class: "text-xs text-slate-500" }
const _hoisted_13 = { class: "font-semibold text-slate-700" }

import { ref, computed } from "vue";

import SkeletonTablas from "@/share/components/SkeletonTablas.vue";
import ErrorState from "@/share/components/ErrorState.vue";
import PaginationCompontens from "@/share/components/PaginationCompontens.vue";
import ConfirmarAccionModal from "@/share/components/ConfirmarAccionModal.vue";
import { gpedPedidosPaginacionFilterParams } from "../interfaces/gpedPedidosPaginacionFilterParams";
import {
  applyPedidosSortField,
  useCambiarEstadoPedido,
  usePedidosList,
  useReconciliarPendientesIzipay,
} from "../composables";
import PedidosFiltros from "@/share/components/PedidosFiltros.vue";
import PedidosPendientesTable from "../components/pedidosPendientesComponents/pedidosPendientesTable.vue";
import EmptyStatePedidos from "@/share/components/EmptyStatePedidos.vue";
import PedidoDetallesModal from "@/share/components/PedidoDetallesModal.vue";
import AdminPageShell from "@/share/components/admin/AdminPageShell.vue";
import { usePedidoDelete } from "../composables/usePedidoDelete";
// Estado de filtros y paginación

export default /*@__PURE__*/_defineComponent({
  __name: 'PedidosPendientesView',
  setup(__props) {

const params = ref<gpedPedidosPaginacionFilterParams>({
  page: 1,
  limit: 10,
  search: "",
  estadoNombre: "Pendiente",
  sortBy: "createdAt",
  sortOrder: "desc",
});
const isModalOpen = ref(false);
const selectedPedidoId = ref("");
const isDelete = ref(false);
const confirmarCambioEstadoOpen = ref(false);
const pedidoIdConfirmacionEstado = ref<string | null>(null);

// Hook de pedidos
const {
  pedidos,
  total,
  totalPages,
  currentPage,
  isPending: isLoadingList,
  isError,
  error,
  refetch,
} = usePedidosList(params);
// Hook de cambio de estado de pedido
const { mutate: cambiarEstado, isPending: isCambiandoEstado } =
  useCambiarEstadoPedido();
const { mutate: detelePedido } = usePedidoDelete(() => {
  isDelete.value = true;
  setTimeout(() => (isDelete.value = false), 100);
});
const {
  mutate: sincronizarPendientesIzipay,
  isPending: isSincronizandoLoteIzipay,
  progresoLotesIzipay,
} = useReconciliarPendientesIzipay();
const confirmarSincronizarLoteIzipayOpen = ref(false);
// Handlers de búsqueda y filtros
const handleSearch = (search: string) => {
  params.value.search = search;
  params.value.page = 1;
};

const handlePageChange = (page: number) => {
  params.value.page = page;
  window.scrollTo({ top: 0, behavior: "smooth" });
};

const handleLimitChange = (limit: number) => {
  params.value.limit = limit;
  params.value.page = 1;
};

const handleSort = (field: string) => {
  applyPedidosSortField(params, field);
};

const pedidoClienteConfirmacion = computed(() => {
  const id = pedidoIdConfirmacionEstado.value;
  if (!id) return "";
  const p = pedidos.value.find((x) => x.id === id);
  if (!p?.cliente) return "";
  return `${p.cliente.nombreCliente} ${p.cliente.apellidoCliente || ""}`.trim();
});

// Acciones de pedidos
const handleViewDetails = (pedidoId: string) => {
  selectedPedidoId.value = pedidoId;
  isModalOpen.value = true;
};
const handleCloseModal = () => {
  isModalOpen.value = false;
};
const handleUpdateEstado = (pedidoId: string) => {
  pedidoIdConfirmacionEstado.value = pedidoId;
  confirmarCambioEstadoOpen.value = true;
};

const cerrarConfirmacionCambioEstado = () => {
  if (isCambiandoEstado.value) return;
  confirmarCambioEstadoOpen.value = false;
  pedidoIdConfirmacionEstado.value = null;
};

const ejecutarCambioEstadoAPagado = () => {
  const id = pedidoIdConfirmacionEstado.value;
  if (!id) return;
  cambiarEstado(
    { pedidoId: id, nombreEstado: "Pagado" },
    {
      onSettled: () => {
        confirmarCambioEstadoOpen.value = false;
        pedidoIdConfirmacionEstado.value = null;
      },
    }
  );
};

const handleDeletePedido = async (pedidoId: string) => {
  detelePedido(pedidoId);
};

const abrirModalSincronizarLoteIzipay = () => {
  if (isSincronizandoLoteIzipay.value) return;
  confirmarSincronizarLoteIzipayOpen.value = true;
};

const cerrarModalSincronizarLoteIzipay = () => {
  if (isSincronizandoLoteIzipay.value) return;
  confirmarSincronizarLoteIzipayOpen.value = false;
};

/** Consulta Izipay por lotes de 30 hasta agotar pendientes con commerceOrder o hasta un lote sin avance a pagado/cancelado. */
const ejecutarSincronizarLoteIzipay = () => {
  sincronizarPendientesIzipay(30, {
    onSettled: () => {
      confirmarSincronizarLoteIzipayOpen.value = false;
      void refetch();
    },
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminPageShell, {
    title: "Pedidos pendientes",
    description: "Pedidos en estado Pendiente: contraentrega, agencia o pasarela (Izipay) con cupón. Marca como Pagado cuando el cobro esté verificado."
  }, {
    lead: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createElementVNode("p", { class: "text-slate-600 hidden sm:block" }, [
        _createTextVNode(" Para cupón / efectivo con pasarela, usa "),
        _createElementVNode("strong", null, "Sincronizar con Izipay"),
        _createTextVNode(" encima de la tabla (lotes de 30 hasta cubrir todos los pendientes con orden de pasarela). Para cobro manual, el ícono "),
        _createElementVNode("strong", { class: "text-blue-700" }, "círculo con check"),
        _createTextVNode(" marca el pedido como pagado. ")
      ], -1)
    ]))]),
    default: _withCtx(() => [
      _createVNode(PedidoDetallesModal, {
        "pedido-id": selectedPedidoId.value,
        "is-open": isModalOpen.value,
        onClose: handleCloseModal
      }, null, 8, ["pedido-id", "is-open"]),
      _createVNode(ConfirmarAccionModal, {
        show: confirmarCambioEstadoOpen.value,
        title: "Confirmar pago / marcar como Pagado",
        loading: _unref(isCambiandoEstado),
        "confirm-label": "Sí, marcar como Pagado",
        "cancel-label": "No, cancelar",
        variant: "danger",
        onCancel: cerrarConfirmacionCambioEstado,
        onConfirm: ejecutarCambioEstadoAPagado
      }, {
        default: _withCtx(() => [
          _createElementVNode("p", null, [
            _cache[3] || (_cache[3] = _createTextVNode(" Vas a cambiar el estado del pedido a ", -1)),
            _cache[4] || (_cache[4] = _createElementVNode("strong", { class: "text-slate-900" }, "Pagado", -1)),
            _cache[5] || (_cache[5] = _createTextVNode(". ", -1)),
            (pedidoClienteConfirmacion.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                  _cache[1] || (_cache[1] = _createTextVNode(" Cliente: ", -1)),
                  _createElementVNode("strong", _hoisted_2, _toDisplayString(pedidoClienteConfirmacion.value), 1),
                  _cache[2] || (_cache[2] = _createTextVNode(". ", -1))
                ]))
              : _createCommentVNode("", true)
          ]),
          _cache[6] || (_cache[6] = _createElementVNode("p", { class: "mt-3 text-slate-700" }, [
            _createTextVNode(" El pedido pasará a la vista de ventas pagadas y esta acción "),
            _createElementVNode("strong", { class: "text-red-700" }, "no se puede deshacer"),
            _createTextVNode(" desde el panel (no hay botón para volver a «Pendiente»). ")
          ], -1)),
          _cache[7] || (_cache[7] = _createElementVNode("p", { class: "mt-2 text-sm text-slate-500" }, " Confirma solo si el cobro o la acreditación ya está verificada según tu proceso interno. ", -1))
        ]),
        _: 1
      }, 8, ["show", "loading"]),
      _createVNode(ConfirmarAccionModal, {
        show: confirmarSincronizarLoteIzipayOpen.value,
        title: "Sincronizar todos con Izipay",
        loading: _unref(isSincronizandoLoteIzipay),
        "confirm-label": "Sí, sincronizar (por lotes)",
        "cancel-label": "Cancelar",
        variant: "primary",
        onCancel: cerrarModalSincronizarLoteIzipay,
        onConfirm: ejecutarSincronizarLoteIzipay
      }, {
        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
          _createElementVNode("p", null, [
            _createTextVNode(" Se consultará el estado en "),
            _createElementVNode("strong", null, "Izipay"),
            _createTextVNode(" por "),
            _createElementVNode("strong", null, "lotes de 30"),
            _createTextVNode(" pedidos en "),
            _createElementVNode("strong", null, "Pendiente"),
            _createTextVNode(" con "),
            _createElementVNode("code", { class: "rounded bg-slate-100 px-1.5 py-0.5 text-xs" }, "commerceOrder"),
            _createTextVNode(" (los más recientes primero), repitiendo el lote hasta que no queden candidatos o hasta un lote sin cambios a pagado/cancelado (por ejemplo, si la pasarela sigue devolviendo «pendiente»). ")
          ], -1),
          _createElementVNode("p", { class: "mt-3 text-slate-700" }, [
            _createTextVNode(" Si Izipay indica "),
            _createElementVNode("strong", null, "pagado"),
            _createTextVNode(", el pedido pasa a "),
            _createElementVNode("strong", null, "Pagado"),
            _createTextVNode(" con la misma lógica que el IPN. Si indica "),
            _createElementVNode("strong", null, "rechazado o anulado"),
            _createTextVNode(", se cancela y se libera stock. ")
          ], -1),
          _createElementVNode("p", { class: "mt-2 text-sm text-slate-500" }, " Al terminar se actualiza el listado y datos del panel. ", -1)
        ]))]),
        _: 1
      }, 8, ["show", "loading"]),
      _createElementVNode("div", _hoisted_3, [
        (_unref(isSincronizandoLoteIzipay) || _unref(isCambiandoEstado))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[9] || (_cache[9] = _createElementVNode("svg", {
                class: "h-10 w-10 shrink-0 animate-spin text-sky-700",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor",
                "aria-hidden": "true"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                })
              ], -1)),
              _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(isSincronizandoLoteIzipay)
                ? "Sincronizando pedidos con Izipay…"
                : "Actualizando estado del pedido…"), 1),
              (_unref(isSincronizandoLoteIzipay) && _unref(progresoLotesIzipay))
                ? (_openBlock(), _createElementBlock("p", _hoisted_6, " Lote " + _toDisplayString(_unref(progresoLotesIzipay).loteIndex) + " · " + _toDisplayString(_unref(progresoLotesIzipay).candidatosEnBd) + " pedido(s) en este lote ", 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createVNode(PedidosFiltros, {
          params: params.value,
          total: _unref(total),
          onSearch: handleSearch,
          onLimitChange: handleLimitChange
        }, null, 8, ["params", "total"]),
        (!_unref(isLoadingList) && !_unref(isError) && _unref(total) > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("p", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(total)), 1),
                _cache[10] || (_cache[10] = _createTextVNode(" pedidos pendientes. ", -1)),
                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "hidden sm:inline" }, " Sincroniza con Izipay por lotes de 30 (repite hasta cubrir todos los que tengan orden de pasarela). ", -1))
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "inline-flex shrink-0 items-center justify-center gap-2 rounded-xl bg-sky-700 px-4 py-2.5 text-sm font-semibold text-white shadow-md transition hover:bg-sky-800 disabled:cursor-not-allowed disabled:opacity-60",
                disabled: _unref(isSincronizandoLoteIzipay),
                onClick: abrirModalSincronizarLoteIzipay
              }, [
                (_openBlock(), _createElementBlock("svg", {
                  class: _normalizeClass(["h-5 w-5 shrink-0", { 'animate-spin': _unref(isSincronizandoLoteIzipay) }]),
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor",
                  "aria-hidden": "true"
                }, [...(_cache[12] || (_cache[12] = [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                  }, null, -1)
                ]))], 2)),
                _cache[13] || (_cache[13] = _createTextVNode(" Sincronizar con Izipay (todos) ", -1))
              ], 8, _hoisted_10)
            ]))
          : _createCommentVNode("", true),
        (_unref(isLoadingList))
          ? (_openBlock(), _createBlock(SkeletonTablas, { key: 2 }))
          : (_unref(isError))
            ? (_openBlock(), _createBlock(ErrorState, {
                key: 3,
                error: _unref(error),
                onRetry: _unref(refetch)
              }, null, 8, ["error", "onRetry"]))
            : (_unref(pedidos).length === 0)
              ? (_openBlock(), _createBlock(EmptyStatePedidos, { key: 4 }))
              : (_openBlock(), _createBlock(PedidosPendientesTable, {
                  key: 5,
                  pedidos: _unref(pedidos),
                  sortField: params.value.sortBy ?? 'createdAt',
                  sortDirection: params.value.sortOrder ?? 'desc',
                  isDelete: isDelete.value,
                  currentPage: _unref(currentPage),
                  pageSize: params.value.limit,
                  "accion-en-proceso": _unref(isCambiandoEstado),
                  "accion-pedido-id": pedidoIdConfirmacionEstado.value,
                  "sincronizando-izipay": _unref(isSincronizandoLoteIzipay),
                  onSort: handleSort,
                  onViewDetails: handleViewDetails,
                  onUpdateEstado: handleUpdateEstado,
                  onDeletePedido: handleDeletePedido
                }, null, 8, ["pedidos", "sortField", "sortDirection", "isDelete", "currentPage", "pageSize", "accion-en-proceso", "accion-pedido-id", "sincronizando-izipay"])),
        (!_unref(isLoadingList) && !_unref(isError) && _unref(total) > 0)
          ? (_openBlock(), _createBlock(PaginationCompontens, {
              key: 6,
              "current-page": _unref(currentPage),
              "total-pages": _unref(totalPages),
              total: _unref(total),
              limit: params.value.limit,
              onPageChange: handlePageChange
            }, null, 8, ["current-page", "total-pages", "total", "limit"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("p", _hoisted_12, [
          _cache[14] || (_cache[14] = _createTextVNode(" Total de pedidos: ", -1)),
          _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(total)), 1)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})